import React from 'react';
import cvData from '../../data/cv';
interface PageProps {
  index: number;
  total: number;
  children: React.ReactNode;
}
/** A physical A4 sheet — identical on screen and in the PDF. */
export function Page({
  index,
  total,
  children
}: PageProps) {
  const {
    profile,
    meta
  } = cvData;
  return <section className="cv-page relative flex flex-col bg-[var(--paper)] text-[var(--ink)] shadow-[0_8px_40px_rgba(26,24,21,0.14)]" style={{
    width: '210mm',
    height: '297mm',
    padding: '14mm 15mm'
  }} data-id="element-173" data-mp="vf7dmrbpc6eh">
      <div className="min-h-0 flex-1 overflow-hidden" data-id="element-174" data-mp="14djcthqmwcij">{children}</div>

      <footer className="mt-auto flex shrink-0 items-center justify-between border-t border-[var(--line)] pt-3 font-mono text-[9px] uppercase tracking-[0.22em] text-[var(--ink-faint)]" data-id="element-175" data-mp="197412i2fds4j">
        <span data-id="element-176" data-mp="1j51o528jtivk">
          {profile.name} · {meta.documentLabel}
        </span>
        <span className="tnum" data-id="element-177" data-mp="1n5kjh69nh72i">
          {String(index).padStart(2, '0')} / {String(total).padStart(2, '0')}
        </span>
      </footer>
    </section>;
}